import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatJournalPath } from "../utils/formatJournalPath";
const VolumeCard = ({ volume, journals }) => {
  const [showAll, setShowAll] = useState(false);

  // 对 journals 按 issued 从大到小排序
  const sortedJournals = journals
    .slice() // 创建副本避免修改原数组
    .sort((a, b) => (b.issued || 0) - (a.issued || 0));

  return (
    <div className="card shadow-sm hover-shadow d-flex">
      <Row>
        <Col xs={12} md={4}>
          <div className="card-img-container">
            <div className="volume-stats mb-3 d-flex">
              <img
                src={volume.cover_image}
                alt="cover"
                style={{
                  height: "300px",
                  objectFit: "cover",
                  width: "auto",
                }}
              />
            </div>
          </div>
        </Col>

        <Col xs={12} md={8}>
          <div className="card-body d-flex flex-column" style={{ flex: "1" }}>
            <div className="issues-list">
              <h5 className="card-title">
                Volume: {sortedJournals[0]?.volume || volume.volume}
              </h5>

              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6>Available Issues:</h6>
                {sortedJournals.length > 4 && (
                  <button
                    className="btn btn-link text-primary p-0 btn-sm"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? "Show Less" : "Show More"}
                  </button>
                )}
              </div>

              {/* 根据状态决定显示数量 */}
              {sortedJournals
                .slice(0, showAll ? sortedJournals.length : 4)
                .map((issue, index) => (
                  <div key={index} className="issue-item mb-2">
                    <Link
                      to={`/issue/${formatJournalPath(issue.jcr)}/${issue.volume}/${issue.issued}`}
                      className="btn btn-outline-primary btn-sm w-100 text-start"
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{`Issue ${issue.issued}`}</strong>
                        </div>
                        <div className="text-end">
                          <small className="text-muted">
                            {issue.total_count} articles
                          </small>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VolumeCard;
